export enum EUploadImageType {
  CONTRACT = "CONTRACT",
  PROFILE = "PROFILE",
  ORGANIZATION = "ORGANIZATION",
}

export interface UploadProgress {
  loaded: number;
  total: number;
}

export interface IUploadResult {
  /** Presigned GET URL — time-limited, so don't persist it. */
  url: string;
  bucket: string;
  key: string;
}
